// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ResizableHorizPart-ResizableHorizPart-module__box--QGE3Y {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
}
.src-components-ResizableHorizPart-ResizableHorizPart-module__drag--rg4dx {
  width: 8px;
  background: #f0f0f0;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
}
.src-components-ResizableHorizPart-ResizableHorizPart-module__dragCenter--BsiHD {
  width: 4px;
  height: 50%;
  max-height: 56px;
  border-radius: 4px;
  background: #bfbfbf;
}
.src-components-ResizableHorizPart-ResizableHorizPart-module__body--mZwZI {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.src-components-ResizableHorizPart-ResizableHorizPart-module__body--mZwZI > * {
  flex: 1;
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/ResizableHorizPart/ResizableHorizPart.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;AACA;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AACF;AAAE;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAEJ","sourcesContent":[".box {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n}\n.drag {\n  width: 8px;\n  background: #f0f0f0;\n  cursor: col-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dragCenter {\n  width: 4px;\n  height: 50%;\n  max-height: 56px;\n  border-radius: 4px;\n  background: #bfbfbf;\n}\n.body {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  & > * {\n    flex: 1;\n    max-width: 100%;\n    max-height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-components-ResizableHorizPart-ResizableHorizPart-module__box--QGE3Y`,
	"drag": `src-components-ResizableHorizPart-ResizableHorizPart-module__drag--rg4dx`,
	"dragCenter": `src-components-ResizableHorizPart-ResizableHorizPart-module__dragCenter--BsiHD`,
	"body": `src-components-ResizableHorizPart-ResizableHorizPart-module__body--mZwZI`
};
export default ___CSS_LOADER_EXPORT___;
